import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { InViewportDirective } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkComponent, MediaModule } from '@spartacus/storefront';
import { SdBannerContentModule } from '../banner-content';
import { SdSimpleBannerComponent } from './simple-banner.component';

@NgModule({
  imports: [
    NgIf,
    AsyncPipe,
    GenericLinkComponent,
    MediaModule,
    SdBannerContentModule,
    InViewportDirective,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.SimpleBannerComponent]: {
          component: SdSimpleBannerComponent,
        },
      },
    }),
  ],
  declarations: [SdSimpleBannerComponent],
})
export class SdSimpleBannerModule {}
